// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"39d2cd3f","453":"b13a2de0","787":"cf07fa8c","977":"8d92693f"}[chunkId] + ".chunk.js";
};